import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './navigation.module.scss';
import * as navigationActions from '../../actions/navigation';
import Icon from '../Icon';
import Button from '../Button';
import Kolofon from '../Kolofon';
import { linkResolver } from '../helper';

class NavigationContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      homelink: props.homelink,
      backlink: props.back,
    };
  }

  componentWillMount() {
    if (this.props.home) {
      this.props.setHomeLink(this.props.home);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      homelink: nextProps.homelink,
      backlink: nextProps.back,
    });
  }

  componentWillUnmount() {
    this.props.toggleNavigation(false);
  }

  render() {
    const cssClass = [styles.nav];
    switch (this.props.x) {
      case 'left':
        cssClass.push(styles.left);
        break;
      default:
        cssClass.push(styles.right);
    }
    switch (this.props.y) {
      case 'bottom':
        cssClass.push(styles.bottom);
        break;
      default:
        cssClass.push(styles.top);
    }
    return (
      <nav className={cssClass.join(' ')}>
        {this.props.back &&
          <Button href={this.state.backlink} className={styles.back}>
            <Icon icon="arrow-back" small />
          </Button>
        }
        {this.props.home && !this.props.onClick &&
          <Button href={this.state.homelink}>
            <Icon icon="home" small />
          </Button>
        }
        {this.props.home && this.props.onClick &&
          <Button onClick={this.props.onClick}>
            <Icon icon="home" small />
          </Button>
        }
        {this.props.nav &&
          <Button onClick={() => this.props.toggleNavigation(!this.props.navToggled)}>
            <Icon icon="bars" small />
          </Button>
        }
        {this.props.kolofon &&
          <Button href={this.props.kolofon}>
            <Icon icon="info" small />
          </Button>
        }
      </nav>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    homelink: state.navigation.homelink,
    navToggled: state.navigation.navToggled,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleNavigation: (toggle) => {
      dispatch(navigationActions.toggleNavigation(toggle));
    },
    setNavigation: (items) => {
      dispatch(navigationActions.setNavigation(items));
    },
    setHomeLink: (url) => {
      dispatch(navigationActions.setHomeLink(url));
    }
  };
}

const Navigation = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NavigationContainer);

Navigation.defaultProps = { };

Navigation.propTypes = { };

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/index.jsx